import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  PlusIcon,
  ResetTimeIcon,
  Typography
} from "@dealer-center/core-components";
import { FranchiseList } from "./FranchiseList";
import { AuditLogTable } from "./AuditLogTable";

export const PagesFranchiseManagementUiDisplay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showAuditLog, setShowAuditLog] = useState(false);

  const handleCreateFranchise = () => {
    navigate("add");
  };

  const handleToggleAuditLog = () => {
    setShowAuditLog(!showAuditLog);
  };

  useEffect(() => {
    document.title = "Franchise Management";
  }, []);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          mb: 4
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
          <Typography variant={"h1"}>Franchise Manager</Typography>
          <Typography variant={"body-md"}>
            Manage automotive franchise information and track changes
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "flex-start",
            mt: { xs: 2, md: 0 }
          }}
        >
          <Button
            analyticsConfiguration={{
              eventName: showAuditLog
                ? "PagesFranchiseManagementUi Hide Audit Log"
                : "PagesFranchiseManagementUi Show Audit Log"
            }}
            buttonStyle="secondary"
            startIcon={<ResetTimeIcon title="Audit Log" />}
            sx={{ mb: { xs: 1, md: 0 }, mr: { md: 2 } }}
            onClick={handleToggleAuditLog}
          >
            Audit Log
          </Button>
          <Button
            analyticsConfiguration={{
              eventName: "PagesFranchiseManagementUi Create New Franchise"
            }}
            buttonStyle="primary"
            disabled={location.pathname.includes("franchiseManagement/add")}
            startIcon={<PlusIcon title="Add Franchise" />}
            onClick={handleCreateFranchise}
          >
            Create New Franchise
          </Button>
        </Box>
      </Box>
      <Box sx={{ mb: 4 }}>
        <Outlet />
      </Box>

      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            lg: showAuditLog ? "3fr 2fr" : "1fr"
          },
          gridTemplateAreas: {
            xs: showAuditLog ? `"audit" "franchise"` : `"franchise"`,
            lg: showAuditLog ? `"franchise audit"` : `"franchise"`
          },
          alignItems: "start"
        }}
      >
        <Box
          sx={{
            gridArea: "franchise",
            minWidth: 0
          }}
        >
          <FranchiseList />
        </Box>

        {showAuditLog && (
          <Box
            sx={{
              gridArea: "audit",
              minWidth: 0
            }}
          >
            <AuditLogTable />
          </Box>
        )}
      </Box>
    </Box>
  );
};
